import { render, staticRenderFns } from "./MaterialReportDetail.vue?vue&type=template&id=40f9a7ac&scoped=true"
import script from "./MaterialReportDetail.vue?vue&type=script&lang=js"
export * from "./MaterialReportDetail.vue?vue&type=script&lang=js"
import style0 from "./MaterialReportDetail.vue?vue&type=style&index=0&id=40f9a7ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f9a7ac",
  null
  
)

export default component.exports